import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: 'Navigation',
    links: [
      { label: 'Home', to: '/' },
      { label: 'Beginner Guide', to: '/guides/how-to-use-kakobuy-spreadsheet' },
      { label: 'Shopping Guides', to: '/#guides' },
    ],
  },
  {
    title: 'Categories',
    links: [
      { label: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html', external: true },
      { label: 'Hoodies & Sweaters', href: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html', external: true },
      { label: 'T-Shirts', href: 'https://kaspreadsheet.com/category-913-T-Shirts.html', external: true },
      { label: 'Jackets', href: 'https://kaspreadsheet.com/category-914-Jackets.html', external: true },
      { label: 'Bags', href: 'https://kaspreadsheet.com/category-921-Bags.html', external: true },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Safety Guide', to: '/guides/safe-kakobuy-spreadsheet-buying-tips' },
      { label: 'Shipping Guide', to: '/guides/kakobuy-spreadsheet-shipping-guide' },
      { label: 'Main Store', href: 'https://kaspreadsheet.com/', external: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative bg-foreground-950 rounded-t-3xl mx-4 md:mx-6 mt-8 overflow-hidden">
      {/* Background watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none opacity-[0.03]">
        <span className="font-heading text-[12vw] font-bold text-white whitespace-nowrap">
          KAKOBUYSPREADSHEET
        </span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-white tracking-tight">
                Kakobuy Spreadsheet
              </h3>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-xs">
              The largest directory and buying guide for kakobuy spreadsheet products. Updated daily with the latest finds.
            </p>
            <p className="mt-3 text-xs text-foreground-500">
              Last Updated: June 2026
            </p>
          </div>

          {/* Link columns */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-white mb-4 tracking-wide">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) =>
                  link.external ? (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-400 hover:text-white transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-foreground-400 hover:text-white transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 Kakobuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors"
            >
              Visit Main Store
            </a>
            <Link
              to="/guides/how-to-use-kakobuy-spreadsheet"
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors"
            >
              Beginner Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}